import React, { useEffect, useState } from "react";
import { Button, Card, Row, Col, Image, Typography } from "antd";
import { ThoughtLeadershipData } from "./mock";
import { Fade } from "react-awesome-reveal";

export const ThoughtLeadership = () => {
  const [selectedId, setSelectedId] = useState<string>("");

  return (
    <>
      <div style={{ marginTop: 20 }}>
        <Typography.Title
          style={{
            // color: "#fff",
            fontWeight: 500,
            marginBottom: 20,
          }}
          level={4}
        >
          Thought Leadership
        </Typography.Title>
        <Fade direction="left" triggerOnce>
          <Row gutter={[20, 20]}>
            {ThoughtLeadershipData.map((item: any, index: number) => {
              let divId = `${index}`;
              return (
                <Col span={6}>
                  <div
                    style={{
                      marginBottom: 20,
                      position: "relative",
                      cursor: "pointer",
                    }}
                    onMouseOver={() => {
                      setSelectedId(divId);
                    }}
                    onMouseLeave={() => {
                      setSelectedId("");
                    }}
                    onClick={() => {
                      if (item.href && item.href.length > 0) {
                        window.open(item.href);
                      }
                    }}
                  >
                    <img
                      src={item.image}
                      style={{
                        maxWidth: "100%",
                        height: 300,
                        objectFit: "cover",
                        width: "100%",
                        borderRadius: 10,
                        opacity: selectedId === divId ? 0.8 : 1,
                      }}
                    />
                    <div
                      style={{
                        position: "absolute",
                        width: "100%",
                        height: "100%",
                        top: 0,
                        display: selectedId === divId ? "block" : "none",
                      }}
                    >
                      <Fade direction="up" triggerOnce>
                        <div
                          style={{
                            padding: 20,
                            // background: "#003087",?
                            borderTopLeftRadius: 10,
                            borderTopRightRadius: 10,
                            background: "rgba(0, 0, 135, 0.5)",
                          }}
                          id="showOverlayDiv"
                        >
                          <div style={{ marginBottom: 10 }}>
                            <Typography.Text
                              style={{ color: "#fff" }}
                              className="textSmall"
                            >
                              {item.title}
                            </Typography.Text>
                          </div>
                          <div>
                            <Typography.Text
                              style={{ color: "#fff" }}
                              className="text"
                            >
                              {item.description}
                            </Typography.Text>
                          </div>
                        </div>
                      </Fade>
                    </div>
                  </div>
                </Col>
              );
            })}
          </Row>
        </Fade>
      </div>
    </>
  );
};
